export default {"src":"/_next/static/media/drip_40.cdf0a148.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};